import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "src/components/ui/Card";
import { Button } from "src/components/ui/Button";
import { CheckCircle } from "lucide-react";
import { ROUTES } from "src/routes/RouteConfig";
import { BookingStepProps } from "../types";
import { DURATION_OPTIONS } from "../constants";
import { getTutorName } from "../utils/tutorHelpers";
import { formatDateForDisplay } from "../utils/timeHelpers";
import ScrollToTop from "src/components/ScrollToTop";

const BookingStepFour: React.FC<BookingStepProps> = ({
  tutor,
  formData,
}) => {
  const navigate = useNavigate();

  const getDurationLabel = (duration: string) => {
    const option = DURATION_OPTIONS.find(opt => opt.value === duration);
    return option?.label || duration;
  };

  return (
    <>
      <ScrollToTop />
      <div className="text-center mb-8">
        <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Demo Booking request received!
        </h1>
        <p className="mt-4 text-xl text-gray-500 max-w-2xl mx-auto">
          Your session with {getTutorName(tutor)} has been booked successfully.
        </p>
      </div>

      <Card className="max-w-2xl mx-auto text-center">
        <CardHeader>
          <div className="mx-auto mb-4">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto" />
          </div>
          <CardTitle>Session Confirmed</CardTitle>
          <CardDescription>
            We've sent a confirmation email with all the details.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="p-4 bg-gray-50 rounded-lg">
            <h3 className="font-medium text-lg mb-2">Session Details</h3>
            <p className="mb-1">
              <span className="font-semibold">Date:</span>{" "}
              {formData.date ? formatDateForDisplay(formData.date) : "No date selected"}
            </p>
            <p className="mb-1">
              <span className="font-semibold">Time:</span> {formData.timeSlot}
            </p>
            <p className="mb-1">
              <span className="font-semibold">Duration:</span>{" "}
              {getDurationLabel(formData.duration)}
            </p>
            <p className="mb-1">
              <span className="font-semibold">Topic:</span> {formData.topic}
            </p>
          </div>
          <p className="text-gray-600">
            You can view and manage your upcoming sessions from your dashboard. 
            The meeting link will be provided 30 minutes before the session.
          </p>
        </CardContent>
        <CardFooter className="justify-center space-x-4">
          <Button
            variant="outline"
            onClick={() => navigate(ROUTES.TUTOR_DASHBOARD.path)}
          >
            Go to Dashboard
          </Button>
          <Button
            className="button-gradient text-white"
            onClick={() => navigate(ROUTES.HOME.path)}
          >
            Return to Home
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};

export default BookingStepFour;